export const locationAttributes = {
  id: true,
  name: true,
  address: {
    name: true,
    city: true,
    country: true,
    postcode: true,
    county: true,
    line1: true,
    line2: true,
    line3: true,
    timezone: true,
    hash: true,
  },
  coordinates: {
    lat: true,
    lon: true,
  },
  departments: {
    name: true,
    phoneNumber: true,
    isDefault: true,
    openingHours: {
      weekDay: true,
      hours: {
        start: true,
        close: true,
      },
      appOnly: true,
    },
    emailAddresses: true,
    hash: true,
  },
  distance: {
    unit: true,
    value: true,
  },
  businessFunctions: true,
  hash: true,
  franchiseHash: true,
  groupHash: true,
  companyHash: true,
};

export default {
  locationAttributes,
};
